import { render, staticRenderFns } from "./e-learningSubCategoryDetail.vue?vue&type=template&id=4d6f8bea"
import script from "./e-learningSubCategoryDetail.vue?vue&type=script&lang=js"
export * from "./e-learningSubCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports